import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './ForgotPassword.css'
import kleidoLogo from "../../../assets/images/Kleido.png" 

const ForgotPassword = ({ forgotPasswordType, close }) => {
  const [input, setInput] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOTPModal, setShowOTPModal] = useState(true);
  const [showResetChoiceModal, setShowResetChoiceModal] = useState(false);
  const navigate = useNavigate();

  const handleSendOTP = () => {
    if (input) {
      alert(`OTP sent to ${forgotPasswordType}: ${input}`);
      setOtpSent(true);
    }
  };

  const handleVerifyOTP = () => {
    if (otp === "1234") {
      alert("OTP verified! You can reset your password.");
      setShowOTPModal(false);
      setShowResetChoiceModal(true);
    } else {
      alert("Incorrect OTP. Try again.");
    }
  };

  const handleResetPasswordNow = () => {
    setShowResetChoiceModal(false);
    navigate("/reset-password"); // Redirect to reset password page
  };

  const handleResetLater = () => {
    setShowResetChoiceModal(false);
    navigate("/home", { state: { showResetButton: true } }); // Navigate to home
  };

/*
const ValidateOTP = async (mobileNumber, otp) => {
  return true
  try {
    const response = await fetch("/api/v1/user/otp/isvalid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ mobileNumber, otp }),
    });

    const data = await response.json();
      return data.success; // Assuming the API returns { success: true/false }
    } catch (error) {
      console.error("Error validating OTP:", error);
      return false;
    }
  };

    const handleOTPSubmit = async () => {
      const isValid = await ValidateOTP(mobileNumber, otp);
      
      if (isValid) {
          setShowOTPModal(false);
          setShowResetChoiceModal(true);
      } else {
          alert("Invalid OTP, please try again.");
      }
     };
  */

  return (
    <div className="popup-overlay">
    <div className="popup-container-one">
      <div style={{display: "flex", flexDirection: "row"}}>
      <img src={kleidoLogo} alt="Kleido" className="h-12 w-12 rounded-lg" />
      <h3 style={{ fontFamily: "Poppins", color: "white", fontSize: "20px", marginTop: 5 }} >Forgot Password</h3>
      </div>
      <div style={{marginTop: 10}}>
      <label style={{ fontFamily: "Poppins", color: "white", marginTop: 10, marginLeft: 5}}
      >
        Enter your Mobile Number:
      </label>
      </div>
      <input 
        type="text" 
        placeholder={`Enter ${forgotPasswordType}`} 
        value={input} 
        onChange={(e) => setInput(e.target.value)}
        style={{background: "none", color: "white", padding: 20, marginTop: 10}} 
      />
      <button 
        onClick={handleSendOTP}
        style={{background: "light gray", color: "white", padding: 20, border: "1px solid gray", marginTop: 20, borderRadius: 20 }}  
      >Send OTP</button>
      <button 
        onClick={close}
        style={{background: "light gray", color: "white", padding: 20, border: "1px solid gray", marginTop: 20, borderRadius: 20, marginLeft: 10 }}  
      >Cancel</button>
   
      {otpSent && (
        <div className="popup-container-two">
          <label style={{ fontFamily: "Poppins", color: "black", fontSize: "17px"}}>Enter OTP:</label>
          <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
          <button onClick={handleVerifyOTP}>Verify OTP</button>
        </div>
      )}

      {/* Password Reset Choice Popup */}
      {showResetChoiceModal && (
        <div className="popup-container-three" style={{fontFamily: "Poppins", color: "black", fontSize: "17px"}}>
          <h3>Would you like to reset your password now?</h3>
            <button onClick={handleResetPasswordNow}>Reset Now</button>
            <button onClick={handleResetLater}>Reset Later</button>
        </div>
      )}
    </div>
    </div>
  );
};

export default ForgotPassword;
